import React from "react";
import styled from "styled-components";
import { useTable, useFlexLayout } from "react-table";

const Styles = styled.div`
  padding: 1rem;
  overflow-x: scroll;
  table {
    border-spacing: 0;
    width: 100%;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
      :nth-child(even) {
        background-color: #f4f9ff;
      }
    }
    thead {
      color: #686868;
      tr {
        border-bottom: solid 1px #000;
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;

      display: flex;

      :last-child {
        border-right: 0;
      }
    }
  }
`;

export function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      defaultColumn: {
        width: 100,
      },
    },
    useFlexLayout
  );

  // Render the UI for your table
  return (
    <Styles>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </Styles>
  );
}
